import PencilSquare from 'assets/images/icons/pencil-square.svg?react';
import { useTranslation } from 'react-i18next';
import { AvailableAmenity } from 'models/Amenity';
import { AvailableRule } from 'models/Rule';
import usePropertiesUpdatingAllowed from 'components/domain/property/usePropertiesUpdatingAllowed';
import Tooltip from 'components/tooltip/Tooltip';
import PropertyEditActionWrapper from '../../../../common/PropertyEditActionWrapper';
import { AmenityEditIconContainer } from './AmenityDescription.styles';
import useEditAmenityModal from './useEditAmenityModal';

const AmenityEditIcon = ({
  amenity,
}: {
  amenity: AvailableAmenity | AvailableRule;
}) => {
  const type = 'amenityType' in amenity ? amenity.amenityType : amenity.rule;
  const { openAmenityEditModal } = useEditAmenityModal(amenity);
  const propertiesUpdatingAllowed = usePropertiesUpdatingAllowed();
  const { t } = useTranslation();

  const tooltipId = `edit-edit-tooltip-${type}`;

  const icon = (
    <AmenityEditIconContainer
      $disabled={!propertiesUpdatingAllowed}
      onClick={propertiesUpdatingAllowed ? openAmenityEditModal : undefined}
      data-testid={`amenity-edit-icon-${type}`}
    >
      <PencilSquare />
    </AmenityEditIconContainer>
  );

  const iconWrapped = propertiesUpdatingAllowed ? (
    <Tooltip
      text={t('pageProperty.amenities.editAmenityTooltip')}
      id={tooltipId}
    >
      {icon}
    </Tooltip>
  ) : (
    icon
  );

  return (
    <PropertyEditActionWrapper tooltipId={tooltipId}>
      {iconWrapped}
    </PropertyEditActionWrapper>
  );
};

export default AmenityEditIcon;
